import { createContext, useContext, useState, useCallback, useEffect } from 'react'
import api from '../lib/axios'

const AuthContext = createContext(null)

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null)
  const [loading, setLoading] = useState(true)

  // Verify stored token on mount
  useEffect(() => {
    const storedUser = localStorage.getItem('specze_user')
    const token = localStorage.getItem('specze_token')

    if (storedUser && token) {
      // Validate token by calling /auth/me
      api.get('/auth/me')
        .then(({ data }) => {
          const userData = data.data ?? data.user ?? data
          localStorage.setItem('specze_user', JSON.stringify(userData))
          setUser(userData)
        })
        .catch(() => {
          // Token expired or invalid
          localStorage.removeItem('specze_token')
          localStorage.removeItem('specze_user')
          setUser(null)
        })
        .finally(() => setLoading(false))
    } else {
      setLoading(false)
    }
  }, [])

  const login = useCallback(async (email, password) => {
    const { data } = await api.post('/auth/login', { email, password })
    localStorage.setItem('specze_token', data.token)
    localStorage.setItem('specze_user',  JSON.stringify(data.user))
    setUser(data.user)
    return data.user
  }, [])

  const register = useCallback(async (payload) => {
    const { data } = await api.post('/auth/register', payload)
    localStorage.setItem('specze_token', data.token)
    localStorage.setItem('specze_user',  JSON.stringify(data.user))
    setUser(data.user)
    return data.user
  }, [])

  const logout = useCallback(async () => {
    try { await api.post('/auth/logout') } catch {}
    localStorage.removeItem('specze_token')
    localStorage.removeItem('specze_user')
    setUser(null)
  }, [])

  const updateUser = useCallback((updated) => {
    const merged = { ...user, ...updated }
    localStorage.setItem('specze_user', JSON.stringify(merged))
    setUser(merged)
  }, [user])

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout, updateUser, isAdmin: user?.role === 'admin' }}>
      {children}
    </AuthContext.Provider>
  )
}

export const useAuth = () => useContext(AuthContext)
